<div class="custom-header">
    <div class="row align-items-center">
        <div class="col d-flex justify-content-center">
            <h4 class="modal-title" id="modal-title">{{ title }}</h4>
        </div>
        <div class="col-auto d-flex justify-content-end" *ngIf="showDelete">
            <button type="button" class="btn-delete" (click)="onDeleteClick.emit()">
                <i class="hgi hgi-stroke hgi-delete-02"></i>
            </button>
        </div>
        <div class="col-auto d-flex justify-content-end">
            <button type="button" class="btn-close" (click)="onCloseClick.emit()">
               <img src="../../../../assets/img/icons/close.svg" alt="Fechar">
            </button>
        </div>
    </div>
    <div *ngIf="subtitle" class="row align-items-center justify-content-center">
        <p class="modal-subtitle">{{subtitle}}</p>
    </div>
</div>
